import { destroy, get, internalPut, post } from '.';
import qs from 'qs';

export const getSettingRequests = ({ filters }) => {
  return get(`/setting-requests?${qs.stringify(filters)}`);
};

export const getSettingRequest = ({ settingRequestId }) => {
  return get(`/setting-requests/${settingRequestId}`);
};

export const createSettingRequest = ({ payload }) => {
  return post(`/setting-requests`, payload);
};

export const updateSettingRequest = ({ settingRequestId, payload }) => {
  return internalPut(`/setting-requests/${settingRequestId}`, payload);
};

export const deleteSettingRequest = ({ settingRequestId, payload }) => {
  return destroy(`/setting-requests/${settingRequestId}`, payload);
};
